import { createApp } from 'vue';

import App from '@/App';
import router from '@/system_modules/router';
// import store from './system_modules/store';

import { createPinia } from 'pinia';

import titleMixin from '@/system_modules/utils/titleMixin';

import PrimeVue from 'primevue/config';
import { FilterMatchMode } from '@primevue/core/api';
// import ToastService from 'primevue/toastservice';
import Lara from '@primevue/themes/lara';


const pinia = createPinia()

const ap = createApp(App)

// ap.use(store)
ap.use(pinia)
ap.use(router)

ap.mixin(titleMixin)


ap.config.globalProperties.$filters = {
    formatDate: value => {
        let d = value.split('-');
        // let m = new Date(0,d[1],0).toLocaleDateString(store.state.lang, {month: 'short'});
        return `${d[2]}.${d[1]}.${d[0]}`;
        // new Date(value).toLocaleDateString(store.state.lang, {
        //     year: 'numeric',
        //     month: 'short',
        //     day: 'numeric'
        // }),
    },

    replace: (str, txt1, txt2) => {
        let re = RegExp(txt1, "img");
        return str.replace(re, txt2);
    },

    capitalize: str => str != '' ? (str.charAt(0).toUpperCase() + str.slice(1)) : '',

    stripTags: str => str != '' ? str.replace(/(<[^>]*>)*/gm, '') : '',

    formatCurrency: (value) => {
        if (value)
            return value.toLocaleString("az-AZ", {
                style: "currency",
                currency: "AZN",
            });
        return value;
    },
}

// ap.config.errorHandler = (err, instance, info) => {
//     return false;
//     // handle error, e.g. report to a service
// }

ap.use(PrimeVue, {
    // unstyled: true,
    theme: {
        preset: Lara,
        options: {
            prefix: 'p',
            // darkModeSelector: 'system',
            darkModeSelector: false,
            cssLayer: true
        }
    },
    handle: {
        borderRadius: '0px'
    },

    // semantic: {
    //     primary: {
    //         50: '{zinc.50}',
    //         100: '{zinc.100}',
    //         200: '{zinc.200}',
    //         300: '{zinc.300}',
    //         400: '{zinc.400}',
    //         500: '{zinc.500}',
    //         600: '{zinc.600}',
    //         700: '{zinc.700}',
    //         800: '{zinc.800}',
    //         900: '{zinc.900}',
    //         950: '{zinc.950}'
    //     },
    //     colorScheme: {
    //         light: {
    //             primary: {
    //                 color: '{zinc.950}',
    //                 inverseColor: '#ffffff',
    //                 hoverColor: '{zinc.900}',
    //                 activeColor: '{zinc.800}'
    //             },
    //             highlight: {
    //                 background: '{zinc.950}',
    //                 focusBackground: '{zinc.700}',
    //                 color: '#ffffff',
    //                 focusColor: '#ffffff'
    //             }
    //         },
    //         dark: {
    //             primary: {
    //                 color: '{zinc.50}',
    //                 inverseColor: '{zinc.950}',
    //                 hoverColor: '{zinc.100}',
    //                 activeColor: '{zinc.200}'
    //             },
    //             highlight: {
    //                 background: 'rgba(250, 250, 250, .16)',
    //                 focusBackground: 'rgba(250, 250, 250, .24)',
    //                 color: 'rgba(255,255,255,.87)',
    //                 focusColor: 'rgba(255,255,255,.87)'
    //             }
    //         }
    //     }
    // }

    filterMatchModeOptions: {
        text: [
            FilterMatchMode.STARTS_WITH,
            FilterMatchMode.CONTAINS,
            FilterMatchMode.NOT_CONTAINS,
            FilterMatchMode.ENDS_WITH,
            FilterMatchMode.EQUALS,
            FilterMatchMode.NOT_EQUALS,
            FilterMatchMode.CONTAINS_REG
        ],
        numeric: [
            FilterMatchMode.EQUALS,
            FilterMatchMode.NOT_EQUALS,
            FilterMatchMode.LESS_THAN,
            FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
            FilterMatchMode.GREATER_THAN,
            FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
        ],
        date: [
            FilterMatchMode.DATE_IS,
            FilterMatchMode.DATE_IS_NOT,
            FilterMatchMode.DATE_BEFORE,
            FilterMatchMode.DATE_AFTER
        ],
        customFilter: [
            FilterMatchMode.EQUALS,
            FilterMatchMode.NOT_EQUALS,
        ],
        grouping: [
            FilterMatchMode.EQUALS,
            FilterMatchMode.NOT_EQUALS,
            FilterMatchMode.IN,
            FilterMatchMode.NOT_IN,
        ],
    }

});


ap.mount('#app');
